// extracted by mini-css-extract-plugin
module.exports = {"menuSectionItemList":"MenuSectionItemList_menuSectionItemList__2shSx","menuSectionItem":"MenuSectionItemList_menuSectionItem__3jIMe"};